import { render, staticRenderFns } from "./DocenteDetalle.vue?vue&type=template&id=f6e561bc&"
import script from "./DocenteDetalle.vue?vue&type=script&lang=js&"
export * from "./DocenteDetalle.vue?vue&type=script&lang=js&"
import style0 from "./DocenteDetalle.vue?vue&type=style&index=0&id=f6e561bc&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports